import { useEffect } from 'react';
import { useSubNav } from '../contexts/SubNavContext';
import './Business.css';

export default function Business() {
    const { setSubNav } = useSubNav();

    useEffect(() => {
        setSubNav([
            { 
                href: '#mark1', 
                label: '사업영역', 
                active: true,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark1')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            },
            { 
                href: '#mark2', 
                label: '보유기술', 
                active: false,
                onClick: (e) => {
                    e.preventDefault();
                    const el = document.getElementById('mark2')
                    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }
        ]);

        return () => setSubNav(null);
    }, [setSubNav]);

    return (
        <>
            <div className="container">
                <div className="cont_visual business">
                    <h2>최적의 IT서비스</h2>
                    <p>비지니스 컨설팅과 시스템 구축/유지보수 사업간의 시너지를 활용하여 산업별 특화된 최적의 솔루션을 제공합니다.</p>
                </div>
                <div className="cont wrap_cont">
                    <div className="cont_p" id="mark1">
                        <h3>사업영역</h3>
                        <div className="cont_diagram">
                            <div className="dir_txt d_txt1">
                                <h4>Consulting</h4>
                                <div className="dir_lst dir_lst1">
                                    <p>풍부한 경험을 바탕으로<br /> IT 기획과 설계 컨설팅 제공</p>
                                    <ul className="d_lst">
                                        <li>BPR/PI</li>
                                        <li>ERP Solution Consulting</li>
                                        <li>Web/App/Back-End Solution</li>
                                        <li>Information Strategy Planning</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="dir_txt d_txt2">
                                <h4>System Integration<br />& Management</h4>
                                <div className="dir_lst dir_lst2">
                                    <p>다양한 플랫폼 기반의 서비스를<br />개발/구축/유지보수 운영을 제공</p>
                                    <ul className="d_lst">
                                        <li>Moblile Platform</li>
                                        <li>MES Solution</li>
                                        <li>Smart Home</li>
                                        <li>Smart Factory</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="dir_txt d_txt3">
                                <h4>Smart Factory</h4>
                                <div className="dir_lst dir_lst3">
                                    <ul className="d_lst">
                                        <li>검사 자동화 로보틱스</li>
                                        <li>MES Solution</li>
                                        <li>적재 알고리즘 기반 차세대 WMS 구축</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="dir_txt d_txt4">
                                <h4>Internet Service</h4>
                                <div className="dir_lst dir_lst4">
                                    <p>Web/App 기반의<br />웹 서비스를 제공</p>
                                    <ul className="d_lst">
                                        <li>SNS</li>
                                        <li>Raffinest</li>
                                        <li>Image Processing</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cont_p" id="mark2">
                        <h3>보유기술</h3>
                        <div className="cont cont_infographic">
                            <div className="info_cont info_cont1">
                                <div className="info_img info_img1"></div>
                                <div className="info_txt info_txt1">
                                    <h4><b>기획 / 설계 / 디자인</b></h4>
                                    <ul>
                                        <li>서비스 플랫폼 기획 / 설계</li>
                                        <li>GIS 플랫폼 기획 / 설계</li>
                                        <li>API 설계 / 개발</li>
                                        <li>소셜 커뮤니티 빌딩</li>
                                        <li>Web 사이트 기획 / 디자인</li>
                                        <li>모바일 서비스 기획 / 디자인</li>
                                        <li>반응형 기획 / 구축</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="info_cont info_cont2">
                                <div className="info_img info_img2"></div>
                                <div className="info_txt info_txt2">
                                    <h4><b>Mobile / Contents</b></h4>
                                    <ul>
                                        <li>Native / Hybrid Mobile App 개발</li>
                                        <li>HTML 5 / Java Script / JQuery</li>
                                        <li>이미지 편집 기술</li>
                                        <li>N 스크린 지원 기술</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="info_cont info_cont3">
                                <div className="info_img info_img3"></div>
                                <div className="info_txt info_txt3">
                                    <h4><b>Commerce</b></h4>
                                    <ul>
                                        <li>결제/정산 등의 금융 모듈 연동</li>
                                        <li>구매/배송/물류 기능 설계 / 개발</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="info_cont info_cont4">
                                <div className="info_img info_img4"></div>
                                <div className="info_txt info_txt4">
                                    <h4><b>Web Application</b></h4>
                                    <ul>
                                        <li>Platform/Language Indepentdent :</li>
                                        <li>- OS : Windows, Linux, Unix</li>
                                        <li>- Framework : Spring, .NET, PHP</li>
                                        <li>- Browser : IE, Chrome, Safari</li>
                                        <li>- DB : MySQL, Orade, MS-SQL, PostGre</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="info_cont info_cont5">
                                <div className="info_img info_img5"></div>
                                <div className="info_txt info_txt5">
                                    <h4><b>Cloud/Big Data</b></h4>
                                    <ul>
                                        <li>가상화 솔루션 설계 / 개발</li>
                                        <li>서비스 관리 모듈 설계 / 개발</li>
                                        <li>VMWare / MongoDB / 데이터 컨버전</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="info_cont info_cont6">
                                <div className="info_img info_img6"></div>
                                <div className="info_txt info_txt6">
                                    <h4><b>Smart Factory</b></h4>
                                    <ul>
                                        <li>도료, 건재, 실리콘 MES 설계/개발</li>
                                        <li>PLC, SCADA, DCS Interfce</li>
                                        <li>KPI 기반 창고 적재 및 출고 알고리즘</li>
                                        <li>WMS 설계, 개발</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
